<div class="d-flex justify-content-between align-items-center mb-4">
  <h1 class="h3 mb-0">{{ 'announcement.create.title' | translate }}</h1>
</div>

<lib-announcement-form
  [isLoading]="isSaving()"
  (announcementSubmit)="onSave($event)"
  (cancelForm)="onCancel()"
></lib-announcement-form>
